import React from 'react';
import PermMediaOutlinedIcon from '@mui/icons-material/PermMediaOutlined';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import CropSquareIcon from '@mui/icons-material/CropSquare';
import AudiotrackIcon from '@mui/icons-material/Audiotrack';
import LayersIcon from '@mui/icons-material/Layers';
import TimelineIcon from '@mui/icons-material/Timeline';
import { ReelElementType } from './reelCanvas.types';
import { FloatingSideKick } from './FloatingSideKick';

export interface SideKickMenuProps {
    /** Adds a new element of the given type to the canvas (audio → timeline). */
    onAdd: (type: ReelElementType) => void;
    layersOpen: boolean;
    onToggleLayers: () => void;
    timelineOpen: boolean;
    onToggleTimeline: () => void;
    disabled?: boolean;
    /** Bounds the menu can be dragged within (the stage). */
    boundsRef: React.RefObject<HTMLElement | null>;
}

/** Reel Maker's SideKick: add media, text, containers and audio; toggle layers and timeline. */
export const SideKickMenu: React.FC<SideKickMenuProps> = ({
    onAdd,
    layersOpen,
    onToggleLayers,
    timelineOpen,
    onToggleTimeline,
    disabled = false,
    boundsRef,
}) => (
    <FloatingSideKick
        boundsRef={boundsRef}
        storageKey="reel-sidekick-expanded"
        groups={[
            [
                { title: 'Add Media', icon: <PermMediaOutlinedIcon fontSize="small" />, onClick: () => onAdd('media'), disabled },
                { title: 'Add Text', icon: <TextFieldsIcon fontSize="small" />, onClick: () => onAdd('text'), disabled },
                { title: 'Add Container', icon: <CropSquareIcon fontSize="small" />, onClick: () => onAdd('container'), disabled },
                { title: 'Add Audio', icon: <AudiotrackIcon fontSize="small" />, onClick: () => onAdd('audio'), disabled },
            ],
            [
                { title: layersOpen ? 'Hide layers' : 'Show layers', icon: <LayersIcon fontSize="small" />, onClick: onToggleLayers, active: layersOpen },
                { title: timelineOpen ? 'Hide timeline' : 'Show timeline', icon: <TimelineIcon fontSize="small" />, onClick: onToggleTimeline, active: timelineOpen },
            ],
        ]}
    />
);

export default SideKickMenu;
